enum GtmEcommerceEventName {
  AddToCart = 'sf.addToCart',
  RemoveFromCart = 'sf.removeFromCart',
  Checkout = 'sf.checkout',
  CheckoutOption = 'sf.checkoutOption',
  Purchase = 'sf.purchase',
}

export default GtmEcommerceEventName;
